"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toOptionList = toOptionList;
/**
 * Prepare data to option data format
 *
 * @param options
 * @returns {{label: *, value: string}[]}
 */
function toOptionList(options) {
  return Object.keys(options).map(function (key) {
    return {
      label: options[key],
      value: key
    };
  });
}